export enum PharmacyManagementSystemIntegrationStepsEnum {
  SelectType = 0,
  PendingConnection = 1, //The second step of PMS
  Finish = 2,
}
